import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'
import {GetTaggingCoverageRequest, RawTaggingCoverageResponse} from './types'

export interface GetTaggingCoverage<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

/**
 * Batched tagging-coverage read for a list of person ids.
 *
 * `clientid` and `season` go in the QUERY STRING ONLY (D-G). The handler decodes
 * body-supplied copies of both and then discards them (ADO 25063), so a
 * body-carried camp id would be silently ignored and the report would describe
 * whichever camp the query string named. Sending them in both places is the
 * exact shape that makes that bug invisible — so the body carries `personIds`
 * and nothing else.
 */
export const getTaggingCoverage: GetTaggingCoverage<
  GetTaggingCoverageRequest,
  RawTaggingCoverageResponse
> = (http, params) => {
  const {ClientID, Season, PersonIDs, Page, PageSize} = params

  const query =
    `?clientid=${ClientID}&season=${Season}` +
    `&page=${Page}&pagesize=${PageSize}`

  return http.request<RawTaggingCoverageResponse>({
    method: 'POST',
    url: `/v2/faces/persons/tagging-coverage${query}`,
    data: {personIds: PersonIDs},
  })
}
